var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.71 5.023c-.566-.98-1.58-1.564-2.71-1.564s-2.144.585-2.71 1.564L2.423 23.848a3.096 3.096 0 0 0 0 3.128 3.097 3.097 0 0 0 2.71 1.565h21.736a3.097 3.097 0 0 0 2.71-1.565 3.096 3.096 0 0 0 0-3.128zm9.136 20.954a1.11 1.11 0 0 1-.978.564H5.132a1.11 1.11 0 0 1-.978-.564 1.109 1.109 0 0 1 0-1.129L15.024 6.023c.294-.509.781-.564.977-.564s.683.055.977.564l10.868 18.825c.295.51.098.959 0 1.129z",
    fill: "#ff0000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.02 22h-.01c-.552 0-.995.448-.995 1s.453 1 1.005 1a1 1 0 0 0 0-2zM16 19.843a1 1 0 0 0 1-1V13a1 1 0 0 0-2 0v5.843a1 1 0 0 0 1 1z",
    fill: "#ff0000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.1d3dd2812135a4df50755380ae0f01d1.svg";
export { ForwardRef as ReactComponent };